import {routes as statementRoutes} from './statement/routes';
import { routes as appointmentsRoutes } from "./appointments/routes";

export const routes = (prefix = `profile`) => [
    ...statementRoutes(prefix),
    ...appointmentsRoutes(prefix),
];
